import {createBrowserRouter, Navigate} from "react-router-dom";
import LogoutPage from "./components/logout/LogoutPage";
import LoginPage from "./components/login/LoginPage";
import React from "react";

export const LOGIN_PAGE = '/boschung/api/common/auth/v1/oauth/login';
export const LOGOUT_PAGE = '/boschung/api/common/auth/v1/oauth/logout';

export const router = createBrowserRouter([
    {
        path: "/boschung/api/common/auth/v1",
        element: <Navigate replace to="oauth/login" />
    },
    {
        path: LOGIN_PAGE,
        element: <LoginPage />,
    },
    {
        path: LOGOUT_PAGE,
        element: <LogoutPage />,
    },
]);